export const LMI_MA_SCRIPT = {
    URL: process.env.MARKETING_ATTRIBUTION_SCRIPT_URL,
}
